import { useReport } from "../../../fetch/fetch.report";
import { EMPTY_REPORT } from "../../../const/typeDefault/ReportDefault";

const ReportTitle = ({ id }: { id: string }) => {
  const { report, isLoading, isError } = useReport(id, EMPTY_REPORT);
  if (isError) return isError.message;
  if (isLoading) return "Loading...";
  return report.title;
};
export default ReportTitle;
